import { render, staticRenderFns } from "./Cell.vue?vue&type=template&id=b55eb0d8&scoped=true&lang=pug"
import script from "./Cell.vue?vue&type=script&lang=ts"
export * from "./Cell.vue?vue&type=script&lang=ts"
import style0 from "./Cell.vue?vue&type=style&index=0&id=b55eb0d8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55eb0d8",
  null
  
)

export default component.exports